import { Box, Paper } from '@material-ui/core';
import FinalizeSectionData from './FinalizeSectionData';
import { useSelector } from 'react-redux';
import UnitSpecification from './UnitSpecification';
import { isPremiumOption } from '../../utils/isPremium';
import LineItem from './LineItem';
import { useEffect } from 'react';
import typography from '../../styles/typography.module.css';
import layout from '../../styles/layout.module.css';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { getTypeOfOption } from '../../utils/getType';
const OrderDetails = ({ height }) => {
    const state = useSelector((state) => state.rootReducer);
    const shell = state.currentShell;
    const faceplate = state.currentFaceplateOption;
    const leftFaceplateType = useMemo(() => {
        return getTypeOfOption(faceplate.leftOption.SK);
    }, []);
    const rightFaceplateType = useMemo(() => {
        return getTypeOfOption(faceplate.rightOption.SK);
    }, []);
    const artwork = state.currentArtwork;
    const cable = state.currentCableOption;
    const carePlanSelected = state.finalizeForm.carePlanSelected;
    const carePlanPrice = state.iemPrice.carePlan;
    // const [heightForRow, setHeightForRow] = useState(height);
    const { t } = useTranslation();
    const currency = useSelector((state) => state.shopifyReducer.ciems[0].currency);
    useEffect(() => {
        // setHeightForRow(height);
    }, [height]);
    return (
        <>
            <h4 className={typography.inBoxTitle} style={{ textAlign: 'center', width: '100%' }}>
                {t('order_details.title')}
            </h4>
            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    color: 'text.primary',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'auto',
                    // height: `${heightForRow}px`
                    marginBottom: '20px'
                }}>
                <Paper elevation={0} className={layout.containerScrollable}>
                    <UnitSpecification
                        title={t('order_details.shell')}
                        left={shell.leftShell}
                        right={shell.rightShell}
                    />
                    <UnitSpecification
                        title={t('order_details.faceplate')}
                        left={faceplate.leftOption}
                        leftType={leftFaceplateType}
                        right={faceplate.rightOption}
                        rightType={rightFaceplateType}
                    />
                    <UnitSpecification
                        title={t('order_details.artwork')}
                        left={isPremiumOption(faceplate.leftOption) ? 'None' : artwork.leftArtwork}
                        right={
                            isPremiumOption(faceplate.rightOption) ? 'None' : artwork.rightArtwork
                        }
                    />
                    <LineItem
                        title={t('order_details.cable')}
                        value={cable.activeCableType.split(' ')[0]}
                        price={`${currency}0.00`}
                    />
                    <LineItem title="" value={cable.activeCableColor} price={`${currency}0.00`} />
                    <LineItem title="" value={cable.activeCableLength} price={`${currency}0.00`} />
                    <LineItem
                        title="Care Plan"
                        value={carePlanSelected}
                        price={`${currency}${
                            carePlanSelected ? parseFloat(carePlanPrice).toFixed(2) : '0.00'
                        }`}
                    />
                    <FinalizeSectionData />
                </Paper>
            </Box>
        </>
    );
};

export default OrderDetails;
